import type { StoreApi } from 'zustand/vanilla';
import DependencyFlowHelper from '../../../helper/DependencyFlowHelper';
import type {
  DataSourceControllerState,
  DependencyFlowInstanceType,
  DependencyFlowStatus,
} from '../types';

const getDataSourceDependencyFlowAction = (
  set: StoreApi<DataSourceControllerState>['setState'],
  get: StoreApi<DataSourceControllerState>['getState'],
) => {
  const setDataSourceDependencyFlowMultiple = ({
    value,
  }: {
    value: DependencyFlowInstanceType;
  }) => {
    set((state) => {
      return {
        ...state,
        dataSourceDependencyFlow: {
          ...state.dataSourceDependencyFlow,
          ...value,
        },
      };
    });
  };

  const setDataSourceInDependencyFlow = ({
    entityId,
    status,
  }: {
    entityId: string;
    status: DependencyFlowStatus;
  }) => {
    const allStagedEntities = DependencyFlowHelper.getDependencyFlowStatus({
      dependencyFlowInstance: get().dataSourceDependencyFlow,
      intraDependencies: get().dataSourceIntraDependencies,
      entities: { [entityId]: { status } },
    });

    setDataSourceDependencyFlowMultiple({ value: allStagedEntities });
  };

  const setDataSourcesDependencyFlow = ({ entities }: { entities: DependencyFlowInstanceType }) => {
    const allStagedEntities = DependencyFlowHelper.getDependencyFlowStatus({
      dependencyFlowInstance: get().dataSourceDependencyFlow,
      entities,
      intraDependencies: get().dataSourceIntraDependencies,
    });
    setDataSourceDependencyFlowMultiple({ value: allStagedEntities });
  };

  const removeDataSourceFromDependencyFlow = ({ entityId }: { entityId: string }) => {
    set((state) => {
      return {
        ...state,
        dataSourceDependencyFlow: {
          ...state.dataSourceDependencyFlow,
          [entityId]: undefined,
        },
      };
    });
  };

  return {
    setDataSourceInDependencyFlow,
    setDataSourcesDependencyFlow,
    removeDataSourceFromDependencyFlow,
  };
};

export default getDataSourceDependencyFlowAction;
